import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { CatalogContainerModel } from '../../../../../models/aggregates/catalog/catalog-container.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Core2Config } from '../shared/core2Config';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel, Pagination, PagingResponseModel } from '../shared';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: "root" })
export class CatalogService extends BaseApiTemplateService<CatalogContainerModel> {
  protected apiUrl: string;

  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.PLATFORM_URL_PREFIX + Core2Config.DOMAIN_PREFIX + "catalogs";
    this.httpClient = http;
  }

  catalogPublic(apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path + "/public";
    }
    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  catalogPrivate(apiVisa: ApiVisa, offset?: number, limit?: number) {
    const validatedOffset = offset == null ? 0 : offset;
    const validatedLimit = offset == null ? 100 : limit;

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/private" +
        `?offset=${validatedOffset}&limit=${validatedLimit}`;
    }

    return this.httpClient.get(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  removeAppletFromCatalog(linkGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/remove-applet/" +
        linkGuid;
    }
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  onSysadminPost(dtoObject: CatalogContainerModel, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url + this.endpoint_path + "/sysadmin-ep";
    }
    return this.httpClient.post(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa),
    );
  }

  onSysadminPut(dtoObject: CatalogContainerModel, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url + this.endpoint_path + "/sysadmin-ep";
    }
    return this.httpClient.put(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(apiVisa),
    );
  }

  getByGuidAsSysAdmin(
    catalogGuid: String,
    apiVisa: ApiVisa,
  ): Observable<BasicApiResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/sysadmin-ep/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  onSysadminRemoveAppletFromCatalog(linkGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/remove-applet/sysadmin-ep/" +
        linkGuid;
    }
    return this.httpClient.put(this.apiUrl, null, this.getHttpHeader(apiVisa));
  }

  onSysadminGetTenantsCount(catalogGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/sysadmin-ep/tenant-count/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<number>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  onSysadminGetAppletCount(catalogGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/sysadmin-ep/applet-count/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<number>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  getByCriteriaAsTenantAdmin(
    pagination: Pagination,
    apiVisa: ApiVisa,
  ): Observable<PagingResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/" +
        apiVisa.tenantCode +
        "/login-tenant-ep" +
        "/query?" +
        pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  getByGuidAsTenantAdmin(
    catalogGuid: String,
    apiVisa: ApiVisa,
  ): Observable<BasicApiResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/" +
        apiVisa.tenantCode +
        "/login-tenant-ep/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  createCatalogeAsTenantAdmin(
    catalog: CatalogContainerModel,
    apiVisa: ApiVisa,
  ): Observable<BasicApiResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep";
    }
    return this.httpClient.post<BasicApiResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      catalog,
      this.getHttpHeader(apiVisa),
    );
  }

  updateCatalogeAsTenantAdmin(
    catalog: CatalogContainerModel,
    apiVisa: ApiVisa,
  ): Observable<BasicApiResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url + this.endpoint_path + "/login-tenant-ep";
    }
    return this.httpClient.put<BasicApiResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      catalog,
      this.getHttpHeader(apiVisa),
    );
  }

  deleteCatalogAsTenantAdmin(catalogGuid: String, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/login-tenant-ep/" +
        catalogGuid;
    }
    return this.httpClient.delete(this.apiUrl, this.getHttpHeader(apiVisa));
  }

  tenantAdminGetAppletCount(catalogGuid: string, apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/login-tenant-ep/applet-count/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<number>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  tenantAdminGetAppletCountByTenantCode(
    tenantCode: string,
    catalogGuid: string,
    apiVisa: ApiVisa,
  ) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/" +
        tenantCode +
        "/login-tenant-ep/applet-count/" +
        catalogGuid;
    }
    return this.httpClient.get<BasicApiResponseModel<number>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  getByCriteriaBackofficeEp(
    pagination: Pagination,
    apiVisa: ApiVisa,
  ): Observable<PagingResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/backoffice-ep" +
        "/query?" +
        pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  // core2/platform/dm/catalogs/{tenantCode}/backoffice-ep/query
  getByCriteriaBackofficeEpFilterByTenant(
    tenantCode: string,
    pagination: Pagination,
    apiVisa: ApiVisa,
  ): Observable<PagingResponseModel<CatalogContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/" +
        tenantCode +
        "/backoffice-ep" +
        "/query?" +
        pagination.getQueryKeyValues();
    }
    return this.httpClient.get<PagingResponseModel<CatalogContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }
  // core2/platform/dm/catalogs/active-counts/sysadmin-ep

  tenantGetAppletCountSysAdminEp(apiVisa: ApiVisa) {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/active-counts/sysadmin-ep";
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl,
      this.getHttpHeader(apiVisa),
    );
  }

  // core2/platform/dm/catalogs/activity-search/sysadmin-ep?email=

  tenantGetActivitySearchSysAdminEp(
  apiVisa: ApiVisa,
  params?: {
    limit?: number;
    offset?: number;
    email?: string;
    name?: string;
    status?: string;
    dateFrom?: string;
    dateTo?: string;
  },
) {
  if (this.endpoint_path && apiVisa.api_domain_url) {
    this.apiUrl =
      apiVisa.api_domain_url +
      this.endpoint_path +
      "/activity-search/sysadmin-ep";
  }

  let httpParams = new HttpParams();

  if (params) {
    if (params.limit != null) {
      httpParams = httpParams.set("limit", params.limit.toString());
    }
    if (params.offset != null) {
      httpParams = httpParams.set("offset", params.offset.toString());
    }
    if (params.email) {
      httpParams = httpParams.set("email", params.email);
    }
    if (params.name) {
      httpParams = httpParams.set("name", params.name);
    }
    if (params.status) {
      httpParams = httpParams.set("status", params.status);
    }
    if (params.dateFrom) {
      httpParams = httpParams.set("dateFrom", params.dateFrom);
    }
    if (params.dateTo) {
      httpParams = httpParams.set("dateTo", params.dateTo);
    }
  }

  return this.httpClient.get<
    BasicApiResponseModel<{
      rows: any[];
      totalRecords: number;
    }>
  >(this.apiUrl, {
    ...this.getHttpHeader(apiVisa),
    params: httpParams,
  });
}

  searchActivitySysAdminEp(
    apiVisa: ApiVisa,
    limit?: number,
    email?: string,
    name?: string,
    status?: string,
    dateFrom?: string,
    dateTo?: string,
  ) {
    let url = this.apiUrl + "/activity-search/sysadmin-ep";

    if (this.endpoint_path && apiVisa.api_domain_url) {
      url =
        apiVisa.api_domain_url +
        this.endpoint_path +
        "/activity-search/sysadmin-ep";
    }

    const queryParams: string[] = [];

    if (limit != null) queryParams.push(`limit=${limit}`);
    if (email) queryParams.push(`email=${encodeURIComponent(email)}`);
    if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
    if (status) queryParams.push(`status=${encodeURIComponent(status)}`);
    if (dateFrom) queryParams.push(`dateFrom=${encodeURIComponent(dateFrom)}`);
    if (dateTo) queryParams.push(`dateTo=${encodeURIComponent(dateTo)}`);

    if (queryParams.length > 0) {
      url += "?" + queryParams.join("&");
    }

    return this.httpClient.get<BasicApiResponseModel<any[]>>(
      url,
      this.getHttpHeader(apiVisa),
    );
  }
}
